import React from 'react'
import { localized } from 'decorators'
import { Button } from 'components/buttons'

export const ListTab = localized(({ classes, localize, children, onRowClick, gridKey }) => {
  return (
    <div>
      <Button icon='plus' onClick={() => onRowClick({ dataItem: { id: 0 }})}>{localize('common.add')}</Button>
      <div className={classes.grid} key={gridKey}>
        {children}
      </div>
    </div>
  )
})
